import React from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import Loader from "../../Loader";
import _axios from "../../../httpService";
import {DeleteBoxInAdminDashboardSetting} from "../../../Assets/svg/index";
import BoxSectionInSettingAdminDashboard from "./BoxSectionInSettingAdminDashboard";
import Swal from "sweetalert2";
import {renderToStaticMarkup} from "react-dom/server";
import {toast} from "react-toastify";
import Button from "../../UI/Button";
import dashboard from "../../../Pages/MainPage/Dashboard";

const AdminDashboardSettings = (props) => {
  const preFixUrl = localStorage.getItem("apiUrl") + "/userDashboard/";

  const [inputFromLocation, setInputFromLocation] = useState({});
  const location = useLocation();
  const navigateTo = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [wrongPath, setWrongPath] = useState(false);

  const [dataState, setDataState] = useState([])
  const [selectOptionList, setSelectOptionList] = useState({table: [], chart: []})

  useEffect(() => {
    if (location.state) {
      const rowData = location.state;
      setInputFromLocation(rowData);
      setIsLoading(false);

      _axios.get(preFixUrl + "?request=dashboardDetail&dashboardId=" + rowData.id).then((response) => {
        let data = response.data;
        // setSelectOptionList(data);
        // برای تست من اینو مقدار دهی میکنم
        // setSelectOptionList({
        //   table: [
        //     {value: 1, text: "جدول 1"},
        //     {value: 2, text: "جدول 2"},
        //     {value: 2, text: "جدول 3"},
        //   ],
        //   chart: [
        //     {value: 1, text: "چارت 1"},
        //     {value: 2, text: "چارت 2"},
        //     {value: 3, text: "چارت 3"},
        //     {value: 4, text: "چارت 4"},
        //   ]
        // });


        setDataState(response.data.details)
      })
      _axios.get(preFixUrl + "?request=reportList").then((response) => {
        let data = response.data;
        setSelectOptionList(data);
        // برای تست من اینو مقدار دهی میکنم
        // setSelectOptionList({
        //   table: [
        //     {value: 1, text: "جدول 1"},
        //     {value: 2, text: "جدول 2"},
        //     {value: 2, text: "جدول 3"},
        //   ],
        //   chart: [
        //     {value: 1, text: "چارت 1"},
        //     {value: 2, text: "چارت 2"},
        //     {value: 3, text: "چارت 3"},
        //     {value: 4, text: "چارت 4"},
        //   ]
      });


    } else {
      setWrongPath(true)
    }


    // setDataState([[{id: "", myId: "", value: "", type: "", title: ""}],])
  }, [location]);


  const showChartSelectOption = () => {
    document.querySelector('.chartSelectOptionToModalAdminDashboard').style.visibility = 'visible';
    document.querySelector('.dataSelectOptionToModalAdminDashboard').style.visibility = "hidden";
  }
  const showTableSelectOption = () => {
    document.querySelector('.chartSelectOptionToModalAdminDashboard').style.visibility = "hidden";
    document.querySelector('.dataSelectOptionToModalAdminDashboard').style.visibility = "visible";
  }
  const [checkModalIsOpen, setCheckModalIsOpen] = useState(false)
  useEffect(() => {
    if (document.getElementById("tableModalForm") !== null) {
      const table = document.getElementById("tableModalForm");
      const chartRadio = table.querySelector("#chartRadioInputToModalAdminDashboard");
      const tableRadio = table.querySelector("#dataRadioInputToModalAdminDashboard");
      chartRadio.addEventListener('click', showChartSelectOption)
      tableRadio.addEventListener('click', showTableSelectOption)
    }
  }, [checkModalIsOpen])

  const getRandomNumber = () => Math.floor(Math.random() * 10000);
  const checkUniqId = (arraysOfObjects, id) => {
    let isUniq = true;
    for (const element of arraysOfObjects) {
      if (element.id === id) {
        isUniq = false;
        break;
      }
    }
    return isUniq;
  }
  const setUniqId = (arraysOfObjects) => {
    let id = getRandomNumber();
    if (checkUniqId(arraysOfObjects, id)) {
      return id
    } else {
      setUniqId(arraysOfObjects)
    }
  }
  const addColum = (v, i) => {
    //setRandom Number
    let newId = setUniqId(v);
    // خیلی وقت گذاشتم اما اینجا استیت آپدت میشد اما کامپوننت رندر نمیشد.
    // طبق تحقیقات اینجا وقتی داریم  استیت رو میدیم به متغیر  سه تا نقطه میزارم تا کپی بشه و آدرسش نیاد  تا کامپوننت دوباره رندر بشه
    setDataState(ps => {
      // طبق تحقیقات اینجا وقتی داریم  استیت رو میدیم به متغیر  سه تا نقطه میزارم تا کپی بشه و آدرسش نیاد  تا کامپوننت دوباره رندر بشه
      const psTemp = [...ps];
      // {id: id, myId: myId, value: value, type: type, title: title}
      psTemp[i] = [...ps[i], {id: newId, value: "", type: "", title: ""}]
      return psTemp;
    })
    // setDataState(ps=>[...ps, [...ps[i],{id: 10, value: "01-1", config: []}]])
  }

  console.log("dataState: ")
  console.log(dataState);
  // setDataState(ps => [...ps,{id: 10, value: "01-1", config: []}])
  const addRow = () => setDataState(ps => [...ps, [{
    id: getRandomNumber(),
    value: "برای افزودن عنوان کلیک کنید",
    type: "",
    title: ""
  }]]);

  const deleteBox = (i, col) => {
    // row.id
    const inText = (col.title === "") ? ("این بخش") : ("بخش"+ " «" + col.title+"»");
    const text = ` آیا از حذف ${inText} مطمئنید؟ `;
    Swal.fire({
      title: "حذف بخش ",
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'بله',
      cancelButtonText: 'خیر'
    }).then((result) => {
      if (result.isConfirmed) {

        setDataState(ps => {
          // طبق تحقیقات اینجا وقتی داریم  استیت رو میدیم به متغیر  سه تا نقطه میزارم تا کپی بشه و آدرسش نیاد  تا کامپوننت دوباره رندر بشه
          let psTemp = [...ps]
          // psTemp[i] = [...ps[i], {id: 10, value: "01-1", config: []}]
          psTemp[i] = psTemp[i].filter((object, index) => object.id !== col.id)
          // اگه فقط یه مورد داشت و حذف کرده بود کلا همون سطر رو از آرایه پاک کن تا به علاوه اضافی نباشه
          //debugger
          if (psTemp[i].length === 0) {
            psTemp = psTemp.filter(arr => arr.length > 0)
          }
          return psTemp;
        })
      }
    })
  }

  // {id: id , myId:myId , value:value , type:type , title:title}
  const addTitleConfig = (i, row, indexBox, id) => {
    // اینجا جای مهمیه قراره مودال باز کنم، چه مودالی
    const htmlString = renderToStaticMarkup(<>
      <div id={"tableModalForm"}>

        <table className={"custom__table__admin__dashboard__settings__modal"}>
          <tr>
            <td></td>
            <td>
              <input
                type="text"
                id="titleOfBox"
                className=" customStyleSelectOptionSweetAlert2"
                placeholder="عنوان را وارد کنید"
              />

            </td>
          </tr>
          <tr>
            <td>
              <div>
                <input
                  name={"chartOrDataSelectToModalAdminDashboard"}
                  id={"chartRadioInputToModalAdminDashboard"} type={"radio"} className={""} value={"chart"}/>
                <label htmlFor={"chartRadioInputToModalAdminDashboard"}> نمودار</label>
              </div>
            </td>
            <td>
              <div className={"chartSelectOptionToModalAdminDashboard "} style={{visibility: 'hidden'}}>
                <select
                  id={"userSelectChartValue"}
                  className="customStyleSelectOptionSweetAlert2" defaultValue={"nullSelect"}>
                  <option value={"nullSelect"} disabled={true} hidden={true}>انتخاب کنید</option>

                  {selectOptionList.chart.map((v, i) => <option key={i} value={v.value}>{v.text}</option>)}
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <input name={"chartOrDataSelectToModalAdminDashboard"} id={"dataRadioInputToModalAdminDashboard"}
                       type={"radio"}
                       value={"table"}/>
                <label htmlFor={"dataRadioInputToModalAdminDashboard"}> جدول</label>
              </div>
            </td>
            <td>
              <div className={"dataSelectOptionToModalAdminDashboard "} style={{visibility: 'hidden'}}>
                <select
                  id={"userSelectDataValue"}
                  className="customStyleSelectOptionSweetAlert2"
                  defaultValue={"nullSelect"}>
                  <option value={"nullSelect"} disabled={true} hidden={true}>انتخاب کنید</option>
                  {selectOptionList.table.map((v, i) => <option key={i} value={v.value}>{v.text}</option>)}

                </select>
              </div>
            </td>
          </tr>
        </table>


        {/**/}


        {/*<div className={"d-flex flex-wrap w-100 "} style={{padding: "0 3em"}}>*/}
        {/*{data.map((v, i) =>*/}
        {/*  <div className="form-check000 text-end" style={{width: "50%"}}>*/}
        {/*    <input value={v} className="form-check-input userList" type="checkbox" id={i}/>*/}
        {/*    <label className="form-check-label " htmlFor={i}>{v}</label>*/}
        {/*  </div>*/}
        {/*)}*/}
        {/*</div>*/}

      </div>
    </>);
    Swal.fire({
      title: '<span class="small" style="color:#309383;">انتخاب نوع اطلاعات</span>',
      html: htmlString,
      confirmButtonText: 'ذخیره',
      confirmButtonAriaLabel: 'buttonModalBackground',
      cancelButtonText: 'لغو',
      focusConfirm: false,
      showCancelButton: false,
      showCloseButton: true,
      allowOutsideClick: false,
      preConfirm: () => {
        const isChartChecked = Swal.getPopup().querySelectorAll('#chartRadioInputToModalAdminDashboard')[0].checked;
        const isTableChecked = Swal.getPopup().querySelectorAll('#dataRadioInputToModalAdminDashboard')[0].checked;

        const chartInputOptionValue = Swal.getPopup().querySelectorAll('#chartRadioInputToModalAdminDashboard')[0].value;
        const tableInputValue = Swal.getPopup().querySelectorAll('#dataRadioInputToModalAdminDashboard')[0].value;
        const type =  // type =   chart OR table
          isChartChecked ?
            chartInputOptionValue :
            isTableChecked ?
              tableInputValue :
              "nullSelect";

        const chartSelectOptionValue = Swal.getPopup().querySelectorAll('#userSelectChartValue')[0].value;
        const tableSelectOptionValue = Swal.getPopup().querySelectorAll('#userSelectDataValue')[0].value;
        const value =
          isChartChecked ?
            chartSelectOptionValue :
            isTableChecked ?
              tableSelectOptionValue :
              "nullSelect";
        const whichSelection = isChartChecked ? "نمودار" : isTableChecked ? "جدول" : "مورد";
        value === "nullSelect" && (Swal.showValidationMessage(`لطفا یک ${whichSelection} انتخاب کنید.`));

        (!isChartChecked && !isTableChecked) && (Swal.showValidationMessage(`لطفا جدول یا نمودار انتخاب کنید.`));

        const title = Swal.getPopup().querySelector('#titleOfBox').value;
        (!title || title.trim().length === 0) && Swal.showValidationMessage(`لطفا  یک عنوان وارد کنید.`);

        return {value: value, type: type, title: title}
      }
    }).then((result) => {
      const {value, type, title} = result.value;
      // const dataToSendBackend = {value, type , title};
      console.log(row, " , ", " , ", i, " , ", indexBox);
      const replaceObject = {id: id, value: value, type: type, title: title}
      setDataState(ps => {
        let psTemp = [...ps];
        const psTempI = [];
        psTemp[i].map((v, psTempIndex) => {
          if (indexBox !== psTempIndex) {
            psTempI.push(v);
          } else {
            psTempI.push(replaceObject);
          }
        });
        psTemp[i] = psTempI;
        return psTemp;
      })
    });

    // اینو گذاشتم تا اگه مودال باز شد اون  افکتی که  توابع داخل مودال هست رو اجرا میکنه
    setCheckModalIsOpen(ps => !ps)
  }

  const submitData = () => {
    // خب رسیدیم به مهمترین قسمت
    // باید قشنگ نگاه کنم ببینم آیا اصلا چیزی مونده که پر نکرده یا نه
    // اگه پر نکرده بود دورش رو قرمز کنم.
    const myPerfectData = [...dataState];
    if (myPerfectData.length === 0) {
      setDataState(myPerfectData)
      toast.error("حداقل یک سطر ایجاد کنید.");
      return
    }
    let shouldISubmit = true;
    for (const rows of myPerfectData) {
      for (const cols of rows) {
        if (cols.value === '' || cols.type === '' || cols.title === '') {
          cols.hasError = true;
          shouldISubmit = false;
        } else {
          cols.hasError = false;
        }
      }
    }
    if (!shouldISubmit) {
      setDataState(myPerfectData)
      toast.error("لطفا داده ها را تکمیل کنید.");
      return
    }

    const payload = {
      request: "dashboardDetail",
      dashboardId: inputFromLocation.id,
      dashboardTitle: inputFromLocation.title,
      details: dataState,
    }
    _axios.post(preFixUrl, payload).then(response => {
      if (response.data.status) {
        toast.success(response.data.message);
        navigateTo(-1);
        // Swal.fire({
        //   title: response.data.message,
        //   icon: 'success',
        //   confirmButtonText: 'باشه',
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     navigateTo(-1);
        //   }
        // })
      } else {
        Swal.fire({
          title: response.data.message,
          icon: 'error',
          confirmButtonText: 'باشه',
        });
      }
    });
  };
  return (<>
    {wrongPath ? <h3 className={"p-5 m-5"}> مقادیر ورودی به صفحه معتبر نیستند. لطفا مجددا تلاش کنید</h3> : isLoading ?
      <Loader/> : <div className={"p-2"}
                       style={{"width": "100%", "height": "90vh", "overflow": "scroll"}}
      >
        <div className={""} style={{width: "1200px", margin: "0 auto"}}>
          <div className={"my-2"}>تنظیمات داشبورد مدیریتی « {inputFromLocation.title} »</div>
          <div className={"d-flex flex-column justify-content-start"}>
            {dataState.map((v, i) =>
              <React.Fragment key={i}>
                <div className={"d-flex flex-wrap justify-content-start"}>
                  {v.map((col, indexBox) => <React.Fragment key={indexBox}>
                    <BoxSectionInSettingAdminDashboard
                      deleteBox={() => deleteBox(i, col)}
                      //( i, row, indexBox, id, myId)
                      addTitleConfig={() => addTitleConfig(i, col, indexBox, col.id,)}
                      titleShow={col.title}
                      hasError={col.hasError}
                    />
                  </React.Fragment>)}
                  {v.length < 4 && <div className={""}
                                        onClick={() => addColum(v, i)}>
                    <div className={"circleAdminDashboard"}>+</div>
                  </div>}
                </div>
              </React.Fragment>)}
            <div onClick={addRow}>
              <div className={"circleAdminDashboard"}><>+</></div>
            </div>
          </div>
        </div>
        <div className={"text-center mt-5"}>
          <Button onClick={submitData}> ثبت </Button>
        </div>
      </div>}
  </>);
};

export default AdminDashboardSettings;
